import { useIntl } from "react-intl";

import { Radio } from "@/components/Radio/Radio";
import { RadioGroup } from "@/components/Radio/RadioGroup";
import { TripType } from "@/features/flights/types/types";

type TripTypeRadioGroupProps = {
  value: TripType;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    value: TripType,
  ) => void;
};

export function TripTypeRadioGroup({
  value,
  onChange,
}: TripTypeRadioGroupProps) {
  const intl = useIntl();

  return (
    <RadioGroup
      row
      className="justify-center gap-6"
      aria-label={intl.formatMessage({ id: "flights.search.tripType" })}
      name="tripType"
      value={value}
      onChange={(event, newValue) => onChange(event, newValue as TripType)}
    >
      <Radio
        value={TripType.ONE_WAY}
        label={intl.formatMessage({ id: "flights.search.oneWay" })}
      />
      <Radio
        value={TripType.ROUND_TRIP}
        label={intl.formatMessage({ id: "flights.search.roundTrip" })}
      />
    </RadioGroup>
  );
}
